import React, { Component } from "react";
import { connect } from "react-redux";
import { CopyToClipboard } from "react-copy-to-clipboard";
import Sidebar from "./sidebar.component";
import Header from "./Header.component";
import { Redirect } from "react-router-dom";
import Send from "./send.component";
import Receive from "./receive.component";
import ContentHeader from "./content-header.component";
import TransactionHistory from "./transactionhistory.component";
import UserService from "../services/user.service";
import { ToastContainer, toast } from "react-toastify";
import { Tabs, Tab } from "react-bootstrap-tabs";
import axios from "axios";
var QRCode = require("qrcode");
class Wallet extends Component {
    constructor(props) {
        super(props);

        this.state = {
            coinDetail: [],
            isLoading: true,
            cointicker: "",
            fiat_currency: "usd",
        };
    }

    async componentWillMount() {
        var cointkr = this.props.match.params.coin;
        if (cointkr == undefined || cointkr == "") {
            this.setState({
                cointicker: "VSOL",
            });
            cointkr = "VSOL";
        } else {
            this.setState({
                cointicker: cointkr,
            });
        }
        await this.loadDetail(cointkr);
    }

    handleChange = async (event) => {
        this.setState(
            {
                fiat_currency: event.target.value,
            },
            () => {
                this.loadDetail().then(() => {
                    this.setState({ isLoading: false });
                });
            }
        );
    };

    loadDetail = async (cointkr) => {
        var coindetailresp = await UserService.getCoindetailbyTicker(cointkr);
        const coindetal = coindetailresp.data.coinDetail;
        let i;
        let newlistdata = [];

        // for (i = 0; i < coindetal.length; i++) {
        var objcoin = {};
        objcoin["Ticker"] = coindetal[0].Ticker;
        objcoin["Addresses"] = coindetal[0].Addresses;
        objcoin["Coinname"] = coindetal[0].Coinname;
        objcoin["ConfirmedBalance"] = coindetal[0].ConfirmedBalance;
        objcoin["Priceapi"] = coindetal[0].Priceapi;
        objcoin["Ticker"] = coindetal[0].Ticker;
        objcoin["TokenType"] = coindetal[0].TokenType;
        var resp = await axios.get(coindetal[0].Priceapi);
        if (resp.data.length == 1) {
            objcoin["change_percentage_24h"] = resp.data[0].price_change_percentage_24h_in_currency;
        } else {
            objcoin["change_percentage_24h"] = 0;
        }
        newlistdata.push(objcoin);
        // }
        this.setState({
            coinDetail: newlistdata[0],
            isLoading: false,
        });
    };

    handleClick = (event) => {
        this.setState({
            loading: true,
        });

        event.preventDefault();

        UserService.combinetx(this.state.cointicker).then(
            (response) => {
                if (response.data.code == 900) {
                    toast.error(response.data.msg);
                    this.setState({
                        loading: false,
                    });
                    return;
                } else if (response.data.code == 100) {
                    //console.log(response.data.tx);
                    toast.success("Transaction Combined Successfully.");
                    this.setState({
                        loading: false,
                    });
                } else {
                    toast.error(response.data.msg);
                    this.setState({
                        loading: false,
                    });
                }
            },
            (error) => {
                toast.error("Internal Server Error, please wait..");
                this.setState({
                    loading: false,
                });
                return;
            }
        );
    };

    render() {
        const { user: currentUser } = this.props;
        if (!currentUser) {
            return <Redirect to="/login" />;
        }

        return (
            <div className="sitemain">
                <Sidebar coin={this.state.cointicker} />
                <main className="main-content">
                    <div className="position-relative">
                        <nav className="nav navbar navbar-expand-lg navbar-light iq-navbar">
                            <div className="container-fluid navbar-inner">
                                <a href="/" className="navbar-brand">
                                    <img src="../assets/images/NOVA-1.png" alt="Nova Wallet" className="logo-img nova-navbar-logo" />
                                </a>
                                <div className="sidebar-toggle" data-toggle="sidebar" data-active="true">
                                    <i className="icon">
                                        <svg width="20px" height="20px" viewBox="0 0 24 24">
                                            <path fill="currentColor" d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                                        </svg>
                                    </i>
                                </div>

                                <button
                                    className="navbar-toggler"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#navbarSupportedContent"
                                    aria-controls="navbarSupportedContent"
                                    aria-expanded="false"
                                    aria-label="Toggle navigation"
                                >
                                    <span className="navbar-toggler-icon">
                                        <span className="navbar-toggler-bar bar1 mt-2"></span>
                                        <span className="navbar-toggler-bar bar2"></span>
                                        <span className="navbar-toggler-bar bar3"></span>
                                    </span>
                                </button>
                                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                                    <ul className="navbar-nav ms-auto align-items-center navbar-list mb-2 mb-lg-0">
                                        <li>
                                            <select className="form-select form-select-sm mb-3 shadow-none" value={this.state.fiat_currency} onChange={this.handleChange}>
                                                <option value="usd">USD</option>
                                                <option value="gbp">GBP</option>
                                                <option value="eur">EUR</option>
                                            </select>
                                        </li>
                                        <li className="nav-item nova-confrmo-nav">
                                            <a href="https://www.confrmo.com" target="_blank" rel="noopener noreferrer" aria-label="Visit Confrmo">
                                                <img src="../assets/images/confrmo.png" alt="Confrmo" />
                                            </a>
                                        </li>
                                        <li className="nav-item ">
                                            <a className="nav-link py-0 d-flex align-items-center" href="https://coinmarketcap.com/currencies/vsolidus/" target="_blank">
                                                <img
                                                    src="../assets/images/coinmarketcap.png"
                                                    alt="CoinMarketcap"
                                                    style={{ width: "50px", height: "50px" }}
                                                    className="img-fluid avatar avatar-50 avatar-rounded"
                                                />
                                            </a>
                                        </li>

                                        <li className="nav-item ">
                                            <a className="nav-link py-0 d-flex align-items-center" href="https://www.coingecko.com/en/coins/vsolidus" target="_blank">
                                                <img
                                                    src="../assets/images/coingeco.png"
                                                    alt="CoinGeco"
                                                    style={{ width: "50px", height: "50px" }}
                                                    className="img-fluid avatar avatar-50 avatar-rounded"
                                                />
                                            </a>
                                        </li>

                                        <li className="nav-item ">
                                            <a className="nav-link py-0 d-flex align-items-center" href={"https://www.bitmart.com/trade/en?symbol=VSOL_USDT&layout=basic"} target="_blank">
                                                <img src="../assets/images/bitmart.png" alt="BitMart" style={{ width: "50px", height: "50px" }} className="img-fluid avatar avatar-50 avatar-rounded" />
                                            </a>
                                        </li>
                                        <li className="nav-item ">
                                            <a className="nav-link py-0 d-flex align-items-center" href={"https://www.bibox.com/en/exchange/basic/VSOL_USDT"} target="_blank">
                                                <img src="../assets/images/bibox.png" alt="BiBox" style={{ width: "50px", height: "50px" }} className="img-fluid avatar avatar-50 avatar-rounded" />
                                            </a>
                                        </li>

                                        {/* <li className="nav-item ">
											<a className="nav-link py-0 d-flex align-items-center" href="https://www.xt.com/tradePro/vsol_usdt" target="_blank" >
												<img src="../assets/images/xt.png" alt="XT" style={{ width: "50px", height: "50px" }} className="img-fluid avatar avatar-50 avatar-rounded" />
											</a>
										</li>

										<li className="nav-item ">
											<a className="nav-link py-0 d-flex align-items-center" href="https://www.hotbit.io/exchange?symbol=VSOL_USDT" target="_blank" >
												<img src="../assets/images/hotbit.png" alt="Hotbit" style={{ width: "50px", height: "50px" }} className="img-fluid avatar avatar-50 avatar-rounded" />
											</a>
										</li> */}
                                    </ul>
                                </div>
                            </div>
                        </nav>
                        <ContentHeader coin={this.state.cointicker} fiat_currency={this.state.fiat_currency} pagename={"Wallet"} />
                    </div>

                    <div className="conatiner-fluid content-inner mt-n5 py-0">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="d-flex flex-wrap align-items-center justify-content-between">
                                            <div className="d-flex flex-wrap align-items-center">
                                                <div className="profile-img position-relative me-3 mb-3 mb-lg-0 profile-logo profile-logo1">
                                                    <img src={"../../assets/images/coins/" + this.state.cointicker + ".png"} className="img-fluid rounded-pill avatar-100" alt="profile-image" />
                                                </div>
                                                <div className="d-flex flex-wrap align-items-center mb-3 mb-sm-0">
                                                    <h4 className="me-2 h4">Wallet</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="card mt-5 border-bottom border-4 border-0 border-primary">
                                    <div className="card-body  mt-5">
                                        <div className="border-bottom text-center pb-3">
                                            <img src={"../assets/images/coins/" + this.state.cointicker + ".png"} alt="profile" className="img-fluid avatar-80 mb-4" />
                                            <div>
                                                <h5 className="mb-3">
                                                    {this.state.coinDetail.TokenType ? (
                                                        <span> {this.state.coinDetail.Coinname + " - " + this.state.coinDetail.TokenType} </span>
                                                    ) : (
                                                        <span>{this.state.coinDetail.Coinname} </span>
                                                    )}
                                                </h5>
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-between mt-3">
                                            <div>
                                                <h5 className="mb-0 counter" style={{ visibility: "visible" }}>
                                                    {this.state.coinDetail.ConfirmedBalance}
                                                </h5>
                                                <div>{this.state.coinDetail.Ticker + " "} Balance</div>
                                            </div>
                                            {this.state.coinDetail.change_percentage_24h > 0 ? (
                                                <div>
                                                    <h5 className="mb-0">
                                                        <span className="text-success">
                                                            <svg width="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path
                                                                    d="M13.131 7.36922C13.189 7.42572 13.437 7.63906 13.641 7.8378C14.924 9.00292 17.024 12.0424 17.665 13.6332C17.768 13.8748 17.986 14.4856 18 14.812C18 15.1247 17.928 15.4228 17.782 15.7073C17.578 16.0619 17.257 16.3463 16.878 16.5022C16.615 16.6025 15.828 16.7584 15.814 16.7584C14.953 16.9143 13.554 17 12.008 17C10.535 17 9.193 16.9143 8.319 16.7867C8.305 16.772 7.327 16.6162 6.992 16.4457C6.38 16.133 6 15.5222 6 14.8685V14.812C6.015 14.3863 6.395 13.491 6.409 13.491C7.051 11.9859 9.048 9.01656 10.375 7.82319C10.375 7.82319 10.716 7.48709 10.929 7.34096C11.235 7.11301 11.614 7 11.993 7C12.416 7 12.81 7.12762 13.131 7.36922Z"
                                                                    fill="currentColor"
                                                                ></path>
                                                            </svg>
                                                            {this.state.coinDetail.change_percentage_24h.toFixed(2)} %
                                                        </span>
                                                        <i className="fa fa-caret-up scale5 ml-2 text-success" aria-hidden="true"></i>
                                                    </h5>
                                                    <div>Change</div>
                                                </div>
                                            ) : (
                                                <div>
                                                    <h5 className="mb-0">
                                                        <span className="text-danger">
                                                            <svg width="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path
                                                                    d="M10.869 16.6308C10.811 16.5743 10.563 16.3609 10.359 16.1622C9.076 14.9971 6.976 11.9576 6.335 10.3668C6.232 10.1252 6.014 9.51437 6 9.18802C6 8.8753 6.072 8.5772 6.218 8.29274C6.422 7.93814 6.743 7.65368 7.122 7.49781C7.385 7.39747 8.172 7.2416 8.186 7.2416C9.047 7.08573 10.446 7 11.992 7C13.465 7 14.807 7.08573 15.681 7.21335C15.695 7.22796 16.673 7.38383 17.008 7.55431C17.62 7.86702 18 8.47784 18 9.13151V9.18802C17.985 9.61374 17.605 10.509 17.591 10.509C16.949 12.0141 14.952 14.9834 13.625 16.1768C13.625 16.1768 13.284 16.5129 13.071 16.659C12.765 16.887 12.386 17 12.007 17C11.584 17 11.19 16.8724 10.869 16.6308Z"
                                                                    fill="currentColor"
                                                                ></path>
                                                            </svg>
                                                            {this.state.coinDetail.change_percentage_24h == null ? 0 : this.state.coinDetail.change_percentage_24h.toFixed(2)}%{" "}
                                                        </span>
                                                        <i className="fa fa-caret-down scale5 ml-2 text-danger" aria-hidden="true"></i>
                                                    </h5>
                                                    <div>Change</div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                {/* {this.state.coinDetail.map((data, index) =>
									this.state.cointicker == data.Ticker ?
										<div className="card active animated zoomInDown" key={index} >
											<a href={"/wallet/" + data.Ticker} className="Acontent" >
												<div className="card-body" style={{ padding: "0.5rem 1.5rem" }}>
													<h5 className="card-title text-primary">{data.Coinname}</h5>
													<div className="d-flex align-items-center justify-content-between">
														<div>
															<h5 className="counter  mb-2" style={{ visibility: "visible" }}>{data.ConfirmedBalance + "   " + data.Ticker} </h5>
															{
																data.change_percentage_24h > 0 ?
																	<h5 className="fs-20 font-w600"><span className="text-success">
																		<svg width="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																			<path d="M13.131 7.36922C13.189 7.42572 13.437 7.63906 13.641 7.8378C14.924 9.00292 17.024 12.0424 17.665 13.6332C17.768 13.8748 17.986 14.4856 18 14.812C18 15.1247 17.928 15.4228 17.782 15.7073C17.578 16.0619 17.257 16.3463 16.878 16.5022C16.615 16.6025 15.828 16.7584 15.814 16.7584C14.953 16.9143 13.554 17 12.008 17C10.535 17 9.193 16.9143 8.319 16.7867C8.305 16.772 7.327 16.6162 6.992 16.4457C6.38 16.133 6 15.5222 6 14.8685V14.812C6.015 14.3863 6.395 13.491 6.409 13.491C7.051 11.9859 9.048 9.01656 10.375 7.82319C10.375 7.82319 10.716 7.48709 10.929 7.34096C11.235 7.11301 11.614 7 11.993 7C12.416 7 12.81 7.12762 13.131 7.36922Z" fill="currentColor"></path>
																		</svg>

																		{data.change_percentage_24h.toFixed(2)} %</span>
																		<i className="fa fa-caret-up scale5 ml-2 text-success" aria-hidden="true"></i>
																	</h5>
																	:
																	<h5 className="fs-20 font-w600"><span className="text-danger">
																		<svg width="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																			<path d="M10.869 16.6308C10.811 16.5743 10.563 16.3609 10.359 16.1622C9.076 14.9971 6.976 11.9576 6.335 10.3668C6.232 10.1252 6.014 9.51437 6 9.18802C6 8.8753 6.072 8.5772 6.218 8.29274C6.422 7.93814 6.743 7.65368 7.122 7.49781C7.385 7.39747 8.172 7.2416 8.186 7.2416C9.047 7.08573 10.446 7 11.992 7C13.465 7 14.807 7.08573 15.681 7.21335C15.695 7.22796 16.673 7.38383 17.008 7.55431C17.62 7.86702 18 8.47784 18 9.13151V9.18802C17.985 9.61374 17.605 10.509 17.591 10.509C16.949 12.0141 14.952 14.9834 13.625 16.1768C13.625 16.1768 13.284 16.5129 13.071 16.659C12.765 16.887 12.386 17 12.007 17C11.584 17 11.19 16.8724 10.869 16.6308Z" fill="currentColor"></path>
																		</svg>
																		{
																			data.change_percentage_24h == null ?
																				0
																				:
																				data.change_percentage_24h.toFixed(2)
																		}
																		% </span>
																		<i className="fa fa-caret-down scale5 ml-2 text-danger" aria-hidden="true"></i>
																	</h5>
															}
														</div>
														<div className="border  bg-soft-danger rounded p-2">
															<img className="" src={"../assets/images/coins/" + data.Ticker + ".png"} style={{ width: "35px", height: "35px" }} />
														</div>
													</div>
												</div>
											</a>
										</div>
										:
										<div className="card  animated zoomInDown" key={index} >
											<a href={"/wallet/" + data.Ticker} className="Acontent" >
												<div className="card-body" style={{ padding: "0.5rem 1.5rem" }}>
													<h5 className="card-title text-primary">{data.Coinname}</h5>
													<div className="d-flex align-items-center justify-content-between">
														<div>
															<h5 className="counter  mb-2" style={{ visibility: "visible" }}>{data.ConfirmedBalance + "   " + data.Ticker} </h5>
															{
																data.change_percentage_24h > 0 ?
																	<h5 className="fs-20 font-w600"><span className="text-success">
																		<svg width="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																			<path d="M13.131 7.36922C13.189 7.42572 13.437 7.63906 13.641 7.8378C14.924 9.00292 17.024 12.0424 17.665 13.6332C17.768 13.8748 17.986 14.4856 18 14.812C18 15.1247 17.928 15.4228 17.782 15.7073C17.578 16.0619 17.257 16.3463 16.878 16.5022C16.615 16.6025 15.828 16.7584 15.814 16.7584C14.953 16.9143 13.554 17 12.008 17C10.535 17 9.193 16.9143 8.319 16.7867C8.305 16.772 7.327 16.6162 6.992 16.4457C6.38 16.133 6 15.5222 6 14.8685V14.812C6.015 14.3863 6.395 13.491 6.409 13.491C7.051 11.9859 9.048 9.01656 10.375 7.82319C10.375 7.82319 10.716 7.48709 10.929 7.34096C11.235 7.11301 11.614 7 11.993 7C12.416 7 12.81 7.12762 13.131 7.36922Z" fill="currentColor"></path>
																		</svg>
																		{data.change_percentage_24h.toFixed(2)} %</span>
																		<i className="fa fa-caret-up scale5 ml-2 text-success" aria-hidden="true"></i>
																	</h5>
																	:
																	<h5 className="fs-20 font-w600"><span className="text-danger">
																		<svg width="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																			<path d="M10.869 16.6308C10.811 16.5743 10.563 16.3609 10.359 16.1622C9.076 14.9971 6.976 11.9576 6.335 10.3668C6.232 10.1252 6.014 9.51437 6 9.18802C6 8.8753 6.072 8.5772 6.218 8.29274C6.422 7.93814 6.743 7.65368 7.122 7.49781C7.385 7.39747 8.172 7.2416 8.186 7.2416C9.047 7.08573 10.446 7 11.992 7C13.465 7 14.807 7.08573 15.681 7.21335C15.695 7.22796 16.673 7.38383 17.008 7.55431C17.62 7.86702 18 8.47784 18 9.13151V9.18802C17.985 9.61374 17.605 10.509 17.591 10.509C16.949 12.0141 14.952 14.9834 13.625 16.1768C13.625 16.1768 13.284 16.5129 13.071 16.659C12.765 16.887 12.386 17 12.007 17C11.584 17 11.19 16.8724 10.869 16.6308Z" fill="currentColor"></path>
																		</svg>
																		{
																			data.change_percentage_24h == null ?
																				0
																				:
																				data.change_percentage_24h.toFixed(2)
																		}
																		% </span>
																		<i className="fa fa-caret-down scale5 ml-2 text-danger" aria-hidden="true"></i>
																	</h5>
															}
														</div>
														<div className="border  bg-soft-danger rounded p-2">
															<img className="" src={"../assets/images/coins/" + data.Ticker + ".png"} style={{ width: "35px", height: "35px" }} />
														</div>
													</div>
												</div>
											</a>
										</div>
								)} */}
                            </div>
                            <div className="col-lg-9">
                                <div className="profile-content tab-content">
                                    {this.state.cointicker == "VSOL" ? (
                                        <div className="row">
                                            <div className="col-md-5">
                                                <a href="https://www.novaexchange.co.uk/" target="_blank" className="btn btn-primary btn-block" style={{ margin: "10px" }}>
                                                    <b>Convert to WVSol</b>
                                                </a>
                                                {/* </div>
												<div className="col-md-3"> */}
                                                <button className="btn btn-primary btn-block" disabled={this.state.loading} onClick={this.handleClick} style={{ margin: "10px" }}>
                                                    {this.state.loading && <span className="spinner-border spinner-border-sm"></span>}
                                                    <span>Combine Tx</span>
                                                </button>
                                            </div>
                                        </div>
                                    ) : (
                                        <div></div>
                                    )}
                                    <div className="row">
                                        <Send coin={this.state.cointicker} />
                                        <Receive coin={this.state.cointicker} />
                                    </div>
                                </div>
                            </div>
                            <TransactionHistory coin={this.state.cointicker} />
                        </div>
                    </div>

                    <div className="footer text-center pl-2">
                        <div className="footer-body">
                            <ul className="left-panel list-inline mb-0 p-0">
                                <li className="list-inline-item">
                                    <a href="https://vsolidus.com/copyrightpolicy/" target="_blank">
                                        Copyright Policy
                                    </a>
                                </li>
                                <li className="list-inline-item">
                                    <a href="https://vsolidus.com/termsandconditions/" target="_blank">
                                        Terms and Conditions
                                    </a>
                                </li>
                                <li className="list-inline-item">
                                    <a href="https://www.vsolidusacademy.com" target="_blank">
                                        VSolidus Academy
                                    </a>
                                </li>
                            </ul>
                            <div className="right-panel">
                                <p>
                                    Copyright ©{" "}
                                    <a href="/" target="_blank">
                                        Nova Web Wallet
                                    </a>{" "}
                                    2026
                                </p>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { user } = state.auth;
    return {
        user,
    };
}

export default connect(mapStateToProps)(Wallet);
